var path = 'app/scripts/modules/core/src/subnet/subnetTag.component.html';
var html = "";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/scripts/modules/core/src/subnet/subnetTag.component.html
// module id = 3260
// module chunks = 0